// client/src/modules/ai-systems/nav.ts
import type { NavItem } from '../types';

/**
 * Navigation items for AI Systems module
 *
 * Organized around jobs-to-be-done for technical backend users:
 * - Dashboard: Overview of AI health + action items
 * - Monitor (dropdown): Outputs, Discovery
 * - Improve (dropdown): Prompts, Campaigns, Experiments
 * - Skills (dropdown): Library of custom Al skills
 * - Automations (dropdown): Agents (Inbox + Activity), Mailroom (Queue + Processors)
 * - Deployments: Ship changes safely
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/ai-systems' },
  {
    label: 'Monitor',
    path: '/ai-systems/outputs',
    children: [
      { label: 'Outputs', path: '/ai-systems/outputs' },
      { label: 'Usage', path: '/ai-systems/usage' },
      { label: 'Discovery', path: '/ai-systems/discovery' },
    ],
  },
  {
    label: 'Improve',
    path: '/ai-systems/prompts',
    children: [
      { label: 'Prompts', path: '/ai-systems/prompts' },
      { label: 'Campaigns', path: '/ai-systems/campaigns' },
      { label: 'Experiments', path: '/ai-systems/experiments' },
    ],
  },
  {
    label: 'Skills',
    path: '/ai-systems/skills',
    children: [
      { label: 'Library', path: '/ai-systems/skills' },
    ],
  },
  {
    label: 'Automations',
    path: '/ai-systems/agents',
    children: [
      { label: 'Agent Inbox', path: '/ai-systems/agents' },
      { label: 'Catch-Up Queue', path: '/ai-systems/catchup' },
      { label: 'Agent Activity', path: '/ai-systems/agents/activity' },
      { label: 'Config Audit', path: '/ai-systems/config-audit' },
      { label: 'Agent Health', path: '/ai-systems/agent-health' },
      { label: 'Work Log', path: '/ai-systems/work-log' },
      // Owner-only, mirroring the route guard and the email_intake_queue rule
      // (mailroom stays Owner-only until the E4f alias reader lists).
      { label: 'Mailroom Queue', path: '/ai-systems/mailroom', requiredRoles: ['Owner'] },
      { label: 'Processors', path: '/ai-systems/mailroom/processors' },
      // Admin-only: matches the route's requireAdmin + the backend
      // requireOrgAdmin gate on every finance_* training callable.
      { label: 'Train fin-ai', path: '/ai-systems/train-fin-ai', requireAdmin: true },
    ],
  },
  { label: 'Deployments', path: '/ai-systems/deployments' },
];
